export const UPDATE_OBSERVACOES_ALUNO = 'UPDATE_OBSERVACOES_ALUNO'
export const ADD_OBSERVACOES_ALUNO = 'ADD_OBSERVACOES_ALUNO'
export const SET_OBSERVACOES_ALUNO = 'SET_OBSERVACOES_ALUNO'
export const REMOVE_OBSERVACOES_ALUNO = 'REMOVE_OBSERVACOES_ALUNO'
export const SET_OBSERVACAO_ALUNO = 'SET_OBSERVACAO_ALUNO'
export const SET_OBSERVACAO_ALUNO_NULL = 'SET_OBSERVACAO_ALUNO_NULL'